import React from 'react';
import { FormProps } from './types';

function Text({
  question, name, onChange, value,
}: FormProps, ref) {
  if (question.type !== 'text') return null;

  return (
    <>
      <div className="dynamic-form-label">{question.label}</div>
      <div className="dynamic-form-input">
        <input type="text" ref={ref} name={name} onChange={onChange} value={value} />
      </div>
    </>
  );
}

export default React.forwardRef(Text);
